// Image Gallery Modal functionality
document.addEventListener("DOMContentLoaded", function() {
    const modal = document.getElementById("imageModal");
    const modalImage = document.getElementById("modalImage");
    const closeModal = document.getElementById("closeModal");
    const galleryItems = document.querySelectorAll(".gallery-item");
    const prevBtn = document.getElementById("prevImage");
    const nextBtn = document.getElementById("nextImage");
    let currentImageIndex = 0;
    let images = [];
    // Build image array from gallery items
    galleryItems.forEach((item, index)=>{
        const img = item.querySelector("img");
        images.push({
            src: img.src,
            alt: img.alt,
            index: index
        });
    });
    // Function to show image at specific index
    function showImage(index) {
        if (index < 0) index = images.length - 1;
        if (index >= images.length) index = 0;
        currentImageIndex = index;
        modalImage.src = images[index].src;
        modalImage.alt = images[index].alt;
        // Update counter if it exists
        const currentCounter = document.getElementById("currentImageIndex");
        const totalCounter = document.getElementById("totalImages");
        if (currentCounter && totalCounter) {
            currentCounter.textContent = index + 1;
            totalCounter.textContent = images.length;
        }
    }
    // Open modal when gallery item is clicked
    galleryItems.forEach((item, index)=>{
        item.addEventListener("click", function() {
            showImage(index);
            modal.classList.remove("hidden");
            document.body.style.overflow = "hidden"; // Prevent body scroll
        });
    });
    // Navigation functions
    function showNextImage() {
        showImage(currentImageIndex + 1);
    }
    function showPrevImage() {
        showImage(currentImageIndex - 1);
    }
    // Navigation button event listeners
    if (nextBtn) nextBtn.addEventListener("click", showNextImage);
    if (prevBtn) prevBtn.addEventListener("click", showPrevImage);
    // Close modal when close button is clicked
    closeModal.addEventListener("click", function() {
        modal.classList.add("hidden");
        document.body.style.overflow = "auto"; // Restore body scroll
    });
    // Close modal when clicking outside the image
    modal.addEventListener("click", function(e) {
        if (e.target === modal) {
            modal.classList.add("hidden");
            document.body.style.overflow = "auto"; // Restore body scroll
        }
    });
    // Keyboard navigation
    document.addEventListener("keydown", function(e) {
        if (!modal.classList.contains("hidden")) switch(e.key){
            case "Escape":
                modal.classList.add("hidden");
                document.body.style.overflow = "auto";
                break;
            case "ArrowLeft":
                e.preventDefault();
                showPrevImage();
                break;
            case "ArrowRight":
                e.preventDefault();
                showNextImage();
                break;
        }
    });
    // Touch/Swipe support
    let startX = null;
    let startY = null;
    const minSwipeDistance = 50;
    modalImage.addEventListener("touchstart", function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
    }, {
        passive: true
    });
    modalImage.addEventListener("touchend", function(e) {
        if (startX === null || startY === null) return;
        const endX = e.changedTouches[0].clientX;
        const endY = e.changedTouches[0].clientY;
        const deltaX = startX - endX;
        const deltaY = startY - endY;
        // Only trigger swipe if horizontal movement is greater than vertical
        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
            if (deltaX > 0) // Swiped left - show next image
            showNextImage();
            else // Swiped right - show previous image
            showPrevImage();
        }
        startX = null;
        startY = null;
    }, {
        passive: true
    });
    // Mouse drag support for desktop
    let isDragging = false;
    let dragStartX = null;
    modalImage.addEventListener("mousedown", function(e) {
        isDragging = true;
        dragStartX = e.clientX;
        modalImage.style.cursor = "grabbing";
        e.preventDefault();
    });
    document.addEventListener("mousemove", function(e) {
        if (!isDragging) return;
        e.preventDefault();
    });
    document.addEventListener("mouseup", function(e) {
        if (!isDragging || dragStartX === null) return;
        const dragEndX = e.clientX;
        const deltaX = dragStartX - dragEndX;
        if (Math.abs(deltaX) > minSwipeDistance) {
            if (deltaX > 0) showNextImage();
            else showPrevImage();
        }
        isDragging = false;
        dragStartX = null;
        modalImage.style.cursor = "pointer";
    });
});

//# sourceMappingURL=jabwedding-parceljs.3e94a0b4.js.map
